/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { CONFIRMATION_BOX_BTN_IDS } from './confirmationDialogConstants';

const CONFIRMATION_CTAS_REPO = {};
CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.PRIMARY] = {
    actionId: CONFIRMATION_BOX_BTN_IDS.PRIMARY,
    actionType: {
        quiet: false,
        variant: 'cta',
    },
};
CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.SECONDARY] = {
    actionId: CONFIRMATION_BOX_BTN_IDS.SECONDARY,
    actionType: {
        quiet: false,
        variant: 'primary',
    },
};
CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.TERTIARY] = {
    actionId: CONFIRMATION_BOX_BTN_IDS.TERTIARY,
    actionType: {
        quiet: false,
        variant: 'primary',
    },
};
CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.WARNING] = {
    actionId: CONFIRMATION_BOX_BTN_IDS.WARNING,
    actionType: {
        quiet: false,
        variant: 'warning',
    },
};

export default CONFIRMATION_CTAS_REPO;
